'use client';

import dynamic from 'next/dynamic';
import ProfileSettingsWrapper from './components/settings-client-wrapper';

const SettingsClientWrapper = dynamic(() => import('./components/settings-client-wrapper'));

const ProfileSettingsTastic = () => {
  return <ProfileSettingsWrapper />;
};

export default ProfileSettingsTastic;
